export function truncateText(s, l) {
  if (!s) return "";
  if (s.length < l) return s;
  return s.substring(0, l - 3) + "...";
}
